export default "__VITE_ASSET__q$HZrqgx__"